import { useMemo, useState } from "react";
import type { RecipeCondition, RecipePreview } from "@/domains/watches/lib/watchTypes";

export function useWatchRecipeState() {
  const [recipeConditions, setRecipeConditions] = useState<RecipeCondition[]>([]);
  const [previewRecipe, setPreviewRecipe] = useState<RecipePreview | null>(null);

  const syncRecipeState = (recipe: RecipePreview | null) => {
    setPreviewRecipe(recipe);
    setRecipeConditions(recipe?.conditions || []);
  };

  const recipeGroupViews = useMemo(
    () =>
      (previewRecipe?.groups || [])
        .map((group) => ({
          ...group,
          conditions: recipeConditions.filter(
            (condition) => (condition.group || "core") === group.id,
          ),
        }))
        .filter((group) => group.conditions.length > 0),
    [previewRecipe, recipeConditions],
  );

  const enabledCoreCount = recipeConditions.filter(
    (condition) => (condition.group || "core") === "core" && condition.enabled,
  ).length;
  const hasValidRecipeSelection =
    !previewRecipe ||
    previewRecipe.core_group_mode !== "at_least_one" ||
    enabledCoreCount > 0;

  const toggleRecipeCondition = (conditionId: string) => {
    setRecipeConditions((current) =>
      current.map((item) =>
        item.id === conditionId
          ? { ...item, enabled: item.required ? true : !item.enabled }
          : item,
      ),
    );
  };

  return {
    recipeConditions,
    setRecipeConditions,
    previewRecipe,
    syncRecipeState,
    recipeGroupViews,
    enabledCoreCount,
    hasValidRecipeSelection,
    toggleRecipeCondition,
  };
}

